import axios from 'axios';
import qs from 'qs';
import get from 'lodash-es/get';
import includes from 'lodash-es/includes';
import { CONTENT_TYPE } from './constant';
import { t as translation } from '../locale';

const axiosInstance = axios.create();

export default (axiosResponse) => {
  return new Promise((resolve, reject) => {
    const serverData = axiosResponse?.data || {};
    const errorCode = serverData?.errorCode;
    const limitBlockMessage = translation('billing.common.limit_block');

    if (errorCode === 201 || axiosResponse.request?.responseURL?.endsWith('/signin')) { //User Log Out
      return reject(new Error('no permission'));
    } else if (errorCode === 7300) { // for recaptcha when the api call meet limit
      if (window.Vue) {
        const vm = new window.Vue();
        const result = serverData.result || {};
        const { data, headers } = axiosResponse.config || {};
        const contentType = get(headers, 'Content-Type');

        if (vm.$createPopupCaptcha && includes(contentType, CONTENT_TYPE.URL_ENCODED)) {
          const popupCaptcha = vm.$createPopupCaptcha({
            type: result.type,
            routingUrl: result.routingUrl || window.resourceAccountIdRoutingURl,
            errorMessage: serverData.errorMessage,
          }, async (captcha) => {
            if (axiosResponse.config) {
              if (contentType === CONTENT_TYPE.URL_ENCODED) {
                axiosResponse.config.data = qs.stringify({ ...qs.parse(data), recaptcha: captcha });
              }
            }

            return axiosInstance(axiosResponse.config)
              .then((result) => {
                popupCaptcha && popupCaptcha.hide();
                resolve(result);
              }, (e) => reject(e));
          });
        }
      }

      // todo the architecture group does not support recapture in application/json format for the time being
      return reject(new Error(limitBlockMessage));
    } else if (errorCode === 7302) { // for block when the api call meet limit
      return reject(new Error(limitBlockMessage));
    } else if (errorCode !== 0 && serverData.errorMessage) {
      return reject(new Error(serverData.errorMessage));
    } else {
      return resolve(serverData);
    }
  });
}
